const PREFIX_REDIRECTS = [
  ["/shop", "/services"],
  ["/product", "/services"],
  ["/product-category", "/services"],
  ["/index.php", "/"],
];

const KEYWORD_REDIRECTS = [
  ["thermostat", "/services"],
  ["air-quality", "/services"],
  ["indoor-air", "/services"],
  ["air-conditioner", "/ac-replacement-estimate"],
  ["new-system", "/ac-replacement-estimate"],
];

const EXACT_REDIRECTS = {
  "/service-call": "/contact",
  "/cart": "/",
  "/checkout": "/",
  "/my-account": "/",
  "/home": "/",
};

// Old-site URL -> new page, evaluated on the trailing-slash-stripped path.
export function resolveLegacyRedirect(path) {
  const lower = path.toLowerCase();
  for (const [prefix, target] of PREFIX_REDIRECTS) {
    if (lower === prefix || lower.startsWith(`${prefix}/`)) return target;
  }
  for (const [keyword, target] of KEYWORD_REDIRECTS) {
    if (lower.includes(keyword)) return target;
  }
  return EXACT_REDIRECTS[lower] || null;
}

// Returns the destination for a pathname, or null when no redirect applies.
export function resolveRedirect(pathname) {
  const stripped = pathname.length > 1 ? pathname.replace(/\/+$/, "") || "/" : pathname;
  const legacy = resolveLegacyRedirect(stripped);
  if (legacy && legacy !== pathname) return legacy;
  if (stripped !== pathname) return stripped;
  return null;
}

// Exact old paths that get prerendered meta-refresh stubs at build time.
export const STATIC_REDIRECT_STUBS = {
  "/shop": "/services",
  "/product": "/services",
  "/product-category": "/services",
  "/service-call": "/contact",
  "/cart": "/",
  "/checkout": "/",
  "/my-account": "/",
  "/Home": "/",
  "/home": "/",
};
